import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  number,
  boolean,
} from 'libs/form';
import { TFunc } from 'libs/i18n';

export interface AccountingSystemFormType {
  sessionLengthInDays: number;
  passwordExpiresInDays?: number;
  isPasswordLimited: boolean;
}

export const getSchema = (t: TFunc): ObjectSchema<AccountingSystemFormType> =>
  object({
    sessionLengthInDays: number()
      .min(
        1,
        t(
          'administration.accountingSystem.authorizationAndSession.sessionLengthInDaysField.errorLength'
        )
      )
      .max(
        30,
        t(
          'administration.accountingSystem.authorizationAndSession.sessionLengthInDaysField.errorLength'
        )
      )
      .required(),

    isPasswordLimited: boolean().required(),

    passwordExpiresInDays: number().when('isPasswordLimited', {
      is: (v: boolean) => v,
      then: (schema) =>
        schema
          .required()
          .min(
            1,
            t(
              'administration.accountingSystem.password.passwordExpiresInDaysField.errorLength'
            )
          )
          .max(
            180,
            t(
              'administration.accountingSystem.password.passwordExpiresInDaysField.errorLength'
            )
          ),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<AccountingSystemFormType>();

export type FormErrors = FormErrorsBase<AccountingSystemFormType>;
